import { storableError } from '../util/errors';
import * as log from '../util/log';
import { fetchDisableRootedRent, updateDisableRootedRent } from '../util/api';
// ================ Action types ================ //

export const FETCH_DISABLE_ROOTED_RENT_REQUEST = 'app/config/FETCH_DISABLE_ROOTED_RENT_REQUEST';
export const FETCH_DISABLE_ROOTED_RENT_SUCCESS = 'app/config/FETCH_DISABLE_ROOTED_RENT_SUCCESS';
export const FETCH_DISABLE_ROOTED_RENT_ERROR = 'app/config/FETCH_DISABLE_ROOTED_RENT_ERROR';

export const UPDATE_DISABLE_ROOTED_RENT_REQUEST = 'app/config/UPDATE_DISABLE_ROOTED_RENT_REQUEST';
export const UPDATE_DISABLE_ROOTED_RENT_SUCCESS = 'app/config/UPDATE_DISABLE_ROOTED_RENT_SUCCESS';
export const UPDATE_DISABLE_ROOTED_RENT_ERROR = 'app/config/UPDATE_DISABLE_ROOTED_RENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchDisableRootedRentInProgress: false,
  fetchDisableRootedRentError: null,
  updateDisableRootedRentInProgress: false,
  updateDisableRootedRentError: null,
  disableAllRootedRent: false,
};

export default function assetReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_DISABLE_ROOTED_RENT_REQUEST:
      return { ...state, fetchDisableRootedRentInProgress: true, fetchDisableRootedRentError: null };
    case FETCH_DISABLE_ROOTED_RENT_SUCCESS:
      return {
        ...state,
        disableAllRootedRent: payload.disableAllRootedRent,
        fetchDisableRootedRentInProgress: false,
      };
    case FETCH_DISABLE_ROOTED_RENT_ERROR:
      return { ...state, fetchDisableRootedRentInProgress: true, fetchDisableRootedRentError: payload };

    case UPDATE_DISABLE_ROOTED_RENT_REQUEST:
      return { ...state, updateDisableRootedRentInProgress: true, updateDisableRootedRentError: null };
    case UPDATE_DISABLE_ROOTED_RENT_SUCCESS: {
      return {
        ...state,
        updateDisableRootedRentInProgress: false,
        disableAllRootedRent: payload.config.disableAllRootedRent,
      };
    }
    case UPDATE_DISABLE_ROOTED_RENT_ERROR:
      return { ...state, updateDisableRootedRentInProgress: false, updateDisableRootedRentError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchDisableRootedRentRequest = () => ({ type: FETCH_DISABLE_ROOTED_RENT_REQUEST });
export const fetchDisableRootedRentSuccess = (payload) => ({
  type: FETCH_DISABLE_ROOTED_RENT_SUCCESS,
  payload,
});
export const fetchDisableRootedRentError = error => ({
  type: FETCH_DISABLE_ROOTED_RENT_ERROR,
  payload: error,
});

const updateDisableRootedRentRequest = () => ({
  type: UPDATE_DISABLE_ROOTED_RENT_REQUEST,
});
export const updateDisableRootedRentSuccess = response => ({
  type: UPDATE_DISABLE_ROOTED_RENT_SUCCESS,
  payload: response,
});
const updateDisableRootedRentError = e => ({
  type: UPDATE_DISABLE_ROOTED_RENT_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchDisableRootedRentConfig = () => (dispatch, getState, sdk) => {
  dispatch(fetchDisableRootedRentRequest());
  return fetchDisableRootedRent()
    .then((res) => {
      dispatch(fetchDisableRootedRentSuccess(res));
    })
    .catch(e => {
      dispatch(fetchDisableRootedRentError(e));
      log.error(e, 'fetch-disable-rooted-rent-value-failed');
    });
};

export const updateDisableRootedRentConfig = isDisabled => (dispatch, getState, sdk) => {
  dispatch(updateDisableRootedRentRequest());
  return updateDisableRootedRent({ disableAllRootedRent: isDisabled })
    .then((res) => {
      dispatch(updateDisableRootedRentSuccess(res));
    })
    .catch(e => {
      dispatch(updateDisableRootedRentError(storableError(e)));
      log.error(e, 'update-disable-rooted-rent-value-failed');
    });
};

